import { __awaiter } from "tslib";
/**
 * 组件使用场景：编辑号牌，添加号牌
 * */
import React, { Component } from 'react';
import { Modal, Form, Input } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { CHECK_buyerCode } from '@/shared/reqexp';
import { fontEndConfig } from '@/shared/utils';
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class AddBuyerComponent extends Component {
    constructor(props) {
        super(props);
        this.ok = () => {
            this.props.form.validateFields()
                .then((formData) => __awaiter(this, void 0, void 0, function* () {
                yield dispatch.buyer.editOrAddCode({
                    newCode: formData.newCode,
                    callback: this.props.onOk || null,
                });
            }));
        };
        this.state = {};
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
    }
    cancel() {
        dispatch.buyer.HIDE_CODE_EDIT();
    }
    afterClose() {
        this.props.form.resetFields();
    }
    renderEdit(editCode) {
        return (<Form.Item labelCol={{ span: 6 }} label={'原号牌'}>
        <span>{editCode}</span>
      </Form.Item>);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { codeShow, editData } = this.props.buyer;
        const editCode = editData.numberPlate === fontEndConfig.noValueReplace ? '' : editData.numberPlate;
        return (<Modal title={editCode ? '修改号牌' : '添加号牌'} centered visible={codeShow} onCancel={this.cancel} afterClose={this.afterClose} okText={editCode ? '确定修改' : '确定添加'} onOk={this.ok}>
        {editCode && this.renderEdit(editCode)}
        <Form.Item labelCol={{ span: 6 }} wrapperCol={{ span: 14 }} label={'新号牌'}>
          {getFieldDecorator('newCode', {
            rules: [
                {
                    required: true,
                    message: '请输入新号牌',
                },
                {
                    pattern: CHECK_buyerCode,
                    message: '请输入1-3位数字号牌(0-999)',
                },
            ],
        })(<Input placeholder={'请输入新号牌'}/>)}
        </Form.Item>
      </Modal>);
    }
}
export default connect(mapStateToProps)(Form.create()(AddBuyerComponent));
